import { uk, type I18nKey } from '@brao/shared';

const dictionaries = { uk } as const;
type Locale = keyof typeof dictionaries;

let current: Locale = 'uk';

export function setLocale(locale: Locale): void {
  current = locale;
}

/** t('common.phase', { n: 1 }) replaces {n} placeholders. */
export function t(key: I18nKey, vars?: Record<string, string | number>): string {
  let s: string = dictionaries[current][key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}
